<nz-table
  #nzTable
  class="v4-layout-list"
  [nzFrontPagination]="false"
  [nzData]="listOfOrder"
  [nzTotal]="total"
  [(nzPageIndex)]="page"
  [nzPageSize]="pageSize"
  nzPaginationType="small"
  [nzShowTotal]="totalTpl"
  (nzPageIndexChange)="onPageChange($event)"
>
  <thead>
    <tr>
      <th>{{ "reservation.table.column.name" | translate }}</th>
      <th>{{ "reservation.table.column.property" | translate }}</th>
      <th>{{ "reservation.table.column.check" | translate }}</th>
      <th>{{ "reservation.table.column.price" | translate }}</th>
      <th>{{ "reservation.table.column.tags" | translate }}</th>
      <th>{{ "reservation.table.column.other_fee" | translate }}</th>
      <th>{{ "reservation.table.column.book_time" | translate }}</th>
      <th></th>
    </tr>
  </thead>
  <tbody class="v4-layout-list-body">
    <tr class="cursor-pointer" *ngFor="let row of nzTable.data" (click)="onClickReservation(row.code)">
      <td>
        <div class="flex flex-row items-center">
          <img class="w-7 h-7 rounded-full mr-3" [src]="row?.logos?.color" alt="" />
          <div>
            <div>{{ row?.client?.name }}</div>
            <div>
              <i nz-icon nzType="team" nzTheme="outline"></i>
              {{ row?.number_of_guests }}
            </div>
          </div>
        </div>
      </td>

      <td>
        <div *ngFor="let item of row.reservations">
          {{ item?.house?.title }}
        </div>
      </td>

      <td>
        <div *ngFor="let item of row.reservations">
          <div class="checkin-range">
            {{ item?.check_in | dateformat : ["MD"] }}~{{ item?.check_out | dateformat : ["MD"] }}
          </div>
          <div
            class="checkin-status"
            [class.wait-stay]="item?.out_status === 'wait_stay'"
            [class.staying]="item?.out_status === 'staying'"
            [class.completed]="item?.out_status === 'completed'"
          >
            {{ "order_status." + item?.out_status | translate }}
          </div>
        </div>
      </td>

      <td>
        <div *ngFor="let item of row.reservations">
          <div class="v4-layout-text-lines">
            <div class="v4-layout-text-line">
              <span>{{ row?.currency_type | currencyToSymbol }}{{ item?.house_fee?.amount }}</span>
              <span *ngIf="[0, 2].indexOf(row?.settlement?.status) !== -1"
                >({{ "order.money_cleared" | translate }})</span
              >
              <span *ngIf="row?.settlement?.status === 1">({{ "order.unpaid" | translate }})</span>
            </div>
            <div class="v4-layout-text-line">
              <span>{{ "word.commission" | translate }} {{ row?.commission?.amount }}</span>
              <span>{{ "order.net_fee" | translate }} {{ row?.net_house_fee?.amount }}</span>
            </div>
          </div>
        </div>
      </td>

      <!-- 标签 -->
      <td>
        <div *ngFor="let item of row.reservations">
          <div class="v4-tag-list">
            <div class="mr-2 py-1">
              <!-- 手工单 -->
              <div class="v4-tag handmade" *ngIf="row.thirdparty_type === 5">
                {{ "order.handmade_order" | translate }}
              </div>
              <!-- 小时单  -->
              <div class="v4-tag hour" *ngIf="item?.is_hour_reservation">
                {{ "order_status.hour_reservation" | translate }}
              </div>
              <!-- 冲突单 -->
              <div class="v4-tag conflict" *ngIf="item?.conflict_label?.is_conflict">
                {{ "order.conflict_order" | translate }}
              </div>
              <!-- 门锁 -->
              <div class="v4-tag smart-lock" *ngIf="item?.tip_no_lock_password">
                {{ "order.no_lock_password" | translate }}
              </div>
            </div>
            <div class="mr-2 py-1" *ngFor="let tag of item?.reservation_tag">
              <div class="v4-tag" [style.background]="tag.color">{{ tag.tag_name }}</div>
            </div>
          </div>
        </div>
      </td>

      <!-- 其他收支 -->

      <td>
        <div class="v4-layout-text-lines">
          <div class="v4-layout-text-line">
            + {{ row?.currency_type | currencyToSymbol }} {{ row?.other_income?.amount }}
          </div>
          <div class="v4-layout-text-line">
            - {{ row?.currency_type | currencyToSymbol }} {{ row?.expense?.amount }}
          </div>
        </div>
      </td>

      <!-- booking time -->
      <td>
        <div class="v4-layout-text-lines">
          <div class="v4-layout-text-link">{{ row?.booked_time | dateformat : ["MD", "hm"] }}</div>
          <div class="v4-layout-text-link">{{ row?.creator?.name }}</div>
        </div>
      </td>

      <td (click)="$event.stopPropagation()">
        <div *ngFor="let item of row.reservations">
          <div class="mb-1">
            <button
              nz-button
              nzSize="small"
              *ngIf="item?.out_status === 'wait_stay'"
              (click)="onClickCheckButton(item)"
            >
              {{ "order.check_in" | translate }}
            </button>
          </div>
          <div class="mb-1">
            <button nz-button nzSize="small" *ngIf="item?.out_status === 'staying'" (click)="onClickCheckButton(item)">
              {{ "order.check_out" | translate }}
            </button>
          </div>
          <div class="mb-1">
            <button
              nz-button
              nzSize="small"
              *ngIf="item?.status === 'wait_accept'"
              (click)="onClickDeclineButton(item)"
            >
              {{ "order.refuse_order" | translate }}
            </button>
          </div>
          <div class="mb-1">
            <button nz-button nzSize="small" *ngIf="item?.status === 'wait_accept'" (click)="onClickAcceptButton(item)">
              {{ "order.accept_order" | translate }}
            </button>
          </div>
          <!-- <div>
            <button
              nz-button
              nzSize="small"
              *ngIf="row?.thirdparty_type !== 5 && [0, 1].indexOf(row?.comment?.status) !== -1"
              (click)="onClickRateButton(row)"
            >
              {{ "rate.operate.btn_rate" | translate }}
            </button>
          </div> -->
        </div>
      </td>
    </tr>
  </tbody>
</nz-table>
<ng-template #totalTpl>
  {{ "component-page_html_总数" | translate : { number: total } }}
  <!-- {{ total }} items -->
</ng-template>
